import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const CallOverlayContext = createContext({
  isOpen: false,
  isMinimized: false,
  callParams: null,
  openCall: () => {},
  closeCall: () => {},
  minimize: () => {},
  expand: () => {},
  toggleMinimize: () => {},
});

export const CallOverlayProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [callParams, setCallParams] = useState(null);

  const openCall = useCallback((params) => {
    setCallParams(params || null);
    setIsOpen(true);
    setIsMinimized(false);
  }, []);

  const closeCall = useCallback(() => {
    setIsOpen(false);
    setIsMinimized(false);
    setCallParams(null);
  }, []);

  const minimize = useCallback(() => {
    setIsMinimized(true);
  }, []);

  const expand = useCallback(() => {
    setIsMinimized(false);
  }, []);

  const toggleMinimize = useCallback(() => {
    setIsMinimized((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({
      isOpen,
      isMinimized,
      callParams,
      openCall,
      closeCall,
      minimize,
      expand,
      toggleMinimize,
    }),
    [isOpen, isMinimized, callParams, openCall, closeCall, minimize, expand, toggleMinimize]
  );

  return <CallOverlayContext.Provider value={value}>{children}</CallOverlayContext.Provider>;
};

export const useCallOverlay = () => useContext(CallOverlayContext);

export default CallOverlayContext;
